import { mdiInformationOutline, mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import "./ExtendSubmitDate.scss";

interface ExtendSubmitDateProps {
  toggleExtendSubmitDateModal: () => void;
  onHandleExtend: () => void;
  newSubmitDate: string;
  setNewSubmitDate: React.Dispatch<React.SetStateAction<string>>;
  minPublishingDate: string;
  extendLoading: boolean;
}

export const ExtendSubmitDate: React.FC<ExtendSubmitDateProps> = ({
  extendLoading,
  toggleExtendSubmitDateModal,
  onHandleExtend,
  newSubmitDate,
  setNewSubmitDate,
  minPublishingDate,
}) => {
  return (
    <div className="confirmation-popup">
      <div className="close-icon" onClick={toggleExtendSubmitDateModal}>
        <Icon className=" mdi-close" path={mdiClose} />
      </div>
      <div className="info-logo">
        <Icon className="mdi-alert" path={mdiInformationOutline}></Icon>
      </div>
      <div>
        <h5 className="text-title">Are you sure you want to extend date?</h5>
      </div>
      <div className="popup-body">
        <div className="alert-section">
          <div>
            <Icon className="mdi-alert" path={mdiInformationOutline}></Icon>
          </div>
          <div>
            <p className="withdraw-bid">
              New Bidders can make bids if the submission deadline is extended.
            </p>
          </div>
        </div>
        <div className="extend-date">
          <input
            className="form-control"
            min={minPublishingDate}
            type="date"
            value={newSubmitDate}
            onChange={(e) => setNewSubmitDate(e.target.value)}
          />
        </div>
      </div>
      <div className="popup-btn">
        <button className="btn-cancel" onClick={toggleExtendSubmitDateModal}>
          Cancel
        </button>
        <button
          className="btn-withdraw"
          onClick={() => {
            onHandleExtend();
          }}
          disabled={extendLoading}
        >
          Extend
        </button>
      </div>
    </div>
  );
};
